import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { ApplyCloseTemplateEntityColumn } from "./applyCloseTemplateEntitySelectionViewConfig";

export const defaultApplyCloseEntitySelectionView: View = {
    type: ViewType.CLOSE_TEMPLATES,
    columns: [
        { id: ApplyCloseTemplateEntityColumn.NAME, options: { pin: "left" } },
        { id: ApplyCloseTemplateEntityColumn.INDUSTRIES },
        { id: ApplyCloseTemplateEntityColumn.LEGAL_TYPE },
        { id: ApplyCloseTemplateEntityColumn.START_DATE },
        { id: ApplyCloseTemplateEntityColumn.END_DATE },
        { id: ApplyCloseTemplateEntityColumn.WORK_START },
        { id: ApplyCloseTemplateEntityColumn.WORK_END },
        { id: ApplyCloseTemplateEntityColumn.PREPARER },
        { id: ApplyCloseTemplateEntityColumn.REVIEWER },
        { id: ApplyCloseTemplateEntityColumn.MANAGER },
        { id: ApplyCloseTemplateEntityColumn.CLIENT },
        { id: ApplyCloseTemplateEntityColumn.PLAN },
        {
            id: ApplyCloseTemplateEntityColumn.SELECT,
            options: { pin: "right" },
        },
    ],
    filters: {},
    options: {
        selection: true,
        bulkActions: true,
        density: ViewDensity.MD,
    },
};
